import React from 'react';
import { Size, FontWeight } from '../../../../styles/theme.mjs';
import Heading from '../../../Typography/Heading/Heading.mjs';
import TextComponent from '../../../Typography/Text/Text.mjs';
import LocationIcon from '../../Icons/LocationIcon.mjs';
import StyledLink from '../../Link/Link.mjs';
import { StyledList, StyledListItem } from './VerticalList.styles.mjs';

const ListElement = ({ isSelected, name, icon }) => (React.createElement(React.Fragment, null,
    icon,
    isSelected && React.createElement(LocationIcon, null),
    React.createElement(TextComponent, { fontWeight: isSelected ? FontWeight.Medium : FontWeight.Regular, tag: "span", size: isSelected ? Size.Medium : Size.Small }, name)));
const VerticalList = ({ heading, options, selectedOption, onClick, withIcon }) => {
    return (React.createElement(React.Fragment, null,
        heading && React.createElement(Heading, { tag: "h3" }, heading),
        React.createElement(StyledList, { withIcon: withIcon }, options === null || options === void 0 ? void 0 : options.map((option, index) => {
            const isSelected = withIcon && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) === option.name;
            return (React.createElement(StyledListItem, { value: option.name, key: index, onClick: () => option && onClick(option) }, option.href ? (React.createElement(StyledLink, { href: option.href },
                React.createElement(ListElement, { name: option.name, isSelected: isSelected, icon: option.icon }))) : (React.createElement(ListElement, { name: option.name, isSelected: isSelected, icon: option.icon }))));
        }))));
};

export { VerticalList as default };
//# sourceMappingURL=VerticalList.mjs.map
